import React from 'react';

const DINING_LOCATION_OPTIONS = [
    { label: "Eating Out", description: "Going to a restaurant", value: "eating_out" },
    { label: "Eating In", description: "Cooking at home", value: "eating_in" },
];

const WelcomeStep = ({ 
    diningLocation, 
    onDiningLocationSelect,
    onNext,
    onBack
}) => {
    const greeting = "Hi, I'm your personal somm! Tell me what you like and I'll find you your perfect wine!";
    const diningLocationQuestion = "Where are you going tonight?";

    return (
        <div className="step-container">
            <h1>{greeting}</h1>
            <h2>{diningLocationQuestion}</h2>
            
            {/* Dining Location Buttons */}
            <div className="preference-buttons">
                {DINING_LOCATION_OPTIONS.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className={`pref-button ${diningLocation === option.value ? 'selected' : ''}`}
                        onClick={() => onDiningLocationSelect(option.value)}
                        title={option.description}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default WelcomeStep;
